import { UntypedFormControl } from '@angular/forms';

export const SafeValueValidator = (formControl: UntypedFormControl) => {
	let isUnsafe = false;
	const text = formControl.value;

	isUnsafe = /[?!@$%^\[\]\{\}\|\<\>\\\;\u2018-\u201F]/i.test(text);

	if (isUnsafe) {
		return { unsafeValue: true };
	} else {
		return null;
	}
};
